// safeHtml.js - Sanitise HTML authored in GBS (passenger notes, stay information) before v-html
import DOMPurify from 'dompurify'

const ALLOWED_TAGS = ['a', 'b', 'strong', 'i', 'em', 'u', 'br', 'p', 'ul', 'ol', 'li']
const ALLOWED_ATTR = ['href', 'target', 'rel']

let purifier = null

function getPurifier() {
    if (purifier) return purifier
    purifier = DOMPurify(window)
    // Links leave the app: always a new tab, never with a handle back to it
    purifier.addHook('afterSanitizeAttributes', (node) => {
        if (node.tagName === 'A') {
            node.setAttribute('target', '_blank')
            node.setAttribute('rel', 'noopener noreferrer')
        }
    })
    return purifier
}

/**
 * GBS HTML reduced to simple formatting and links; scripts, styles, event
 * handlers and javascript: URLs are removed. Empty or non-string input gives ''.
 * @param {unknown} html
 * @returns {string}
 */
export function sanitizeHtml(html) {
    if (typeof html !== 'string' || !html.trim()) return ''
    return getPurifier().sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR })
}
